var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 18 18"}},_vm.$listeners),[_c('path',{attrs:{"fill":"#747C90","d":"m9 9.879 3.713-3.712 1.06 1.06L9 12 4.227 7.227l1.06-1.06z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }